<template>
  <div class="backes">
    <div class="lbj">
      <div class="middle_bar">
        <div class="chat_content">
          <span>文章名称：</span>
          <el-input
            type="text"
            placeholder="请输入文章名称"
            v-model="msgFilter"
            clearable
            @clear="clearContent"
          ></el-input>
        </div>

        <div class="chat_date">
          <span>聊天日期：</span>
          <el-date-picker
            v-model="dateRange1"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="clearContent1"
          ></el-date-picker>
        </div>

        <button class="query" @click="queryuu">搜索</button>
        <button class="querye" @click="querye">重置</button>
      </div>
      <div class="cardlist">
        <div class="card" v-for="(item, index) in cardlistes" :key="index">
          <div class="imgon">
            <img :src="item.coverImage" alt />
          </div>
          <div class="cardxx">
            <div class="cardxx_title">
              <div class="titlebb">{{ item.title }}</div>
              <div class="titbutton" @click="lookxz(item)">查看</div>
            </div>
            <div class="cardtime">
              <img src="../../assets/goods/time.png" alt />
              <span>{{ item.createTime }}</span>
              <img
                src="../../assets/goods/book.png"
                alt
                style="position: absolute;left: 185px;"
              />
              <span style="position: absolute;left: 218px;"
                >{{ item.pageView }}次</span
              >
            </div>
            <!-- <div class="cardneirong" v-html="item.content"></div> -->
          </div>
        </div>
      </div>
      <div class="block">
        <el-pagination
          background="red"
          layout="prev, pager, next"
          :total="yeshu"
          :page-size="searchParams.pageSize"
          @prev-click="handlePrevCilickChange"
          @next-click="handleNextCilickChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { useRouter } from 'vue-router'
import { getCurrentInstance, onMounted, ref, reactive } from 'vue'

export default {
  setup () {
    const { proxy } = getCurrentInstance()
    const searchParams = reactive({
      createTimeAfter: '',
      createTimeBefore: '',
      title: '',
      cateId: 0,
      current: 1,
      pageSize: 4
    })

    const dateRange = ref('')
    const router = useRouter()
    const msgFilter = ref('')
    const xzdetail = ref([])
    const cardlistes = ref([])
    const dateRange1 = ref([])
    const yeshu = ref('')
    const lookxz = item => {
      console.log(item)
      router.push({
        path: `/goods/zixunxq`,
        query: {
          informationId: item.informationId
        }
      })
    }
    const query = () => {
      let param = {}
      // console.log(dateRange1.value[0])
      if (searchParams.createTimeAfter) {
        param.createTimeAfter = searchParams.createTimeAfter
      }

      if (searchParams.createTimeBefore) {
        param.createTimeBefore = searchParams.createTimeBefore
      }

      if (searchParams.title) {
        param.title = searchParams.title
      }

      if (searchParams.cateId) {
        param.cateId = searchParams.cateId
      }
      if (searchParams.current) {
        param.current = searchParams.current
      }
      if (searchParams.pageSize) {
        param.pageSize = searchParams.pageSize
      }
      proxy.$get('/v3/cms/front/information/list', param).then(res => {
        cardlistes.value = res.data.informationList
        xzdetail.value = res.data.cateList
        yeshu.value = res.data.pagination.rowsCount
      })
    }
    const handlePrevCilickChange = e => {
      searchParams.current = e
      query()
    }
    const handleNextCilickChange = e => {
      searchParams.current = e
      query()
    }
    const handleCurrentChange = e => {
      searchParams.current = e
      query()
    }
    const clearContent1 = () => {
      timeFormat(dateRange1.value[0])
    }
    const queryuu = () => {
      let item0 = dateRange1.value[0] //开始时间
      let item1 = dateRange1.value[1] //结束时间
      let ccc = timeFormat(item0)
      let cccc = timeFormat(item1)
      searchParams.createTimeAfter = ccc
      searchParams.createTimeBefore = cccc
      searchParams.title = msgFilter.value
      query()
      msgFilter.value = ''
      dateRange1.value = ''
    }
    //重置
    const querye = () => {
      msgFilter.value = ''
      dateRange1.value = ''
      searchParams.title = ''
      searchParams.createTimeAfter = ''
      searchParams.createTimeBefore = ''
      query()
    }
    const timeFormat = time => {
      let date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      let times = y + '-' + m + '-' + d
      return times
    }

    onMounted(() => {
      query()
    })
    return {
      searchParams,
      cardlistes,
      msgFilter,
      // clearContent,
      xzdetail,
      lookxz,
      dateRange,
      clearContent1,
      dateRange1,
      queryuu,
      yeshu,
      querye,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange
    }
  }
}
</script>
<style lang="scss" scoped>
.block {
  margin-top: 59px;
}
.cardneirong {
  color: rgba(16, 16, 16, 100);
  font-size: 20px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-top: 9px;
}
.cardtime {
  position: relative;
  margin-top: 50px;
}
.cardtime img {
  width: 24px;
  height: 24px;
}
.cardtime span {
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  position: absolute;
  bottom: 5px;
  left: 30px;
}
.cardxx_title {
  display: flex;
  justify-content: space-between;
}
.titbutton {
  width: 89px;
  height: 35px;
  line-height: 35px;
  border-radius: 3px;
  background-color: #00a2e8;
  color: rgba(255, 255, 255, 100);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  cursor: pointer;
}
.titlebb {
  color: rgba(16, 16, 16, 100);
  font-size: 28px;
  text-align: left;
  font-family: SourceHanSansSC-bold;
}
.cardlist {
  margin-top: 40px;
}
.cardxx {
  margin-left: 22px;
  width: 795px;
}
.card {
  background-color: white;
  height: 225px;
  width: 100%;
  margin-bottom: 20px;
  padding: 14px 22px;
  box-sizing: border-box;
  display: flex;
}
.imgon {
  width: 328px;
  height: 186px;
  background-color: #f4f4f4;
  img {
    width: 100%;
    height: 100%;
  }
}
.lbj {
  width: 1200px;
  margin: 0 auto;
}
.querye {
  width: 89px;
  height: 35px;
  line-height: 20px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 100);
  color: #00a2e8;
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid #00a2e8;
  margin-left: 4px;
}
.backes {
  background-color: #f4f4f4;
  overflow: hidden;
}
.middle_bar {
  width: 100%;
  height: 69px;
  display: flex;
  align-items: center;
  background-color: white;
  margin-top: 11px;
  padding: 0px 113px;
  .acc_name {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-right: 100px;
  }

  .chat_content {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;

    input {
      outline: none;
      width: 246px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      border-radius: 3px;
    }

    span {
      display: inline-block;
      width: 105px;
    }

    ::-webkit-input-placeholder {
      position: relative;
      left: 7px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }

    /* 使用webkit内核的浏览器 */
    :-moz-placeholder {
      position: relative;
      left: 7px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }

    /* Firefox版本4-18 */
    ::-moz-placeholder {
      position: relative;
      left: 7px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }

    /* Firefox版本19+ */
    :-ms-input-placeholder {
      position: relative;
      left: 7px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }

    /* IE浏览器 */
  }

  .chat_date {
    display: flex;
    align-items: center;
    margin-left: 50px;
  }

  .query {
    width: 89px;
    height: 35px;
    line-height: 35px;
    border-radius: 3px;
    background-color: #00a2e8;
    color: rgba(255, 255, 255, 100);
    font-size: 14px;
    text-align: center;
    font-family: Roboto;
    border: 0px;
    margin-left: 27px;
  }
}
</style>
